<template>
  <div>
    <el-dialog
      :title="'内外网映射'"
      :visible="netmap"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="close()"
      width="65%">
      <div>
        <el-form ref="typeFormData" name="typeFormData" :model="typeFormData" label-width="110px">
          <el-row style="font-size:16px; margin-bottom: 20px;">内网IP：{{ipItem.ipStr}}</el-row>
          <el-row>
            <el-table
              ref="priNetPlaneTable"
              :data="wanIpTableData"
              tooltip-effect="dark" @selection-change="handleSelectionChangePrivateChoice"
              style="width: 100%">
              <el-table-column type="selection" width="60" align="center" :selectable="selectTable"></el-table-column>
              <el-table-column align="center" property="ipStr" label="ip地址"></el-table-column>
              <el-table-column align="center" property="netPlaneName" label="网络平面名称"></el-table-column>
              <el-table-column align="center" property="ispName" label="所属运营商"></el-table-column>
              <el-table-column align="center" prop="operate" label="操作" width="400">
                <template v-slot="{row}">
                  <el-radio-group v-if="row.isSelect" v-model="row.netType" size="mini">
                    <el-radio border label="NAT" style="margin-right: 1px;"></el-radio>
                    <el-radio border label="NAPT" style="margin-right: 1px;"></el-radio>
                  </el-radio-group>
                  <span v-if="row.status == false">{{row.message}}</span>
                  <el-button v-if="row.isSelect && row.netType == 'NAPT'" style="margin-left: 10px;" size="mini"
                             type="primary" @click="setPort(row)">设置端口
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <el-row style="text-align: center; margin-top: 20px">
            <el-button type="primary" @click="setNatMapping">提 交</el-button>
            <el-button @click="resetForm(false)">取 消</el-button>
          </el-row>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      :title="'端口映射'"
      :visible="portMap"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%">
      <el-form label-position="left" style="margin-left: -60px" ref="portFormData" :model="portFormData"
               label-width="110px" :rules="rules">
        <el-form-item>
          <div v-for="(port, index) in portFormData.ports" :key="index">
            <el-row>
              <el-col :span="7" class="portDiv">
                <el-form-item label="内网端口" :prop="'ports.'+index+'.srcPort'" :rules="rules.port">
                  <el-input style="margin-left: -30px" v-model="port.srcPort" placeholder="请输入端口号" type="number" min="0"
                            max="65535"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7" class="portDiv">
                <el-form-item label="外网端口" :prop="'ports.'+index+'.dstPort'" :rules="rules.port">
                  <el-input style="margin-left: -30px" v-model="port.dstPort" placeholder="请输入端口号" type="number" min="0"
                            max="65535"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" class="portDiv">
                <el-form-item label="协议">
                  <el-select style="margin-left: -60px" v-model="port.protocol">
                    <el-option :value="3" label="TCP/UDP"></el-option>
                    <el-option :value="2" label="TCP"></el-option>
                    <el-option :value="1" label="UDP"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col align="center" :span="2" class="operateIcon">
                <div style="margin-left: -30px" class="el-icon-circle-plus" @click="addNaptPort()"></div>
              </el-col>
              <el-col align="center" :span="2" class="operateIcon" v-if="portFormData.ports.length > 1">
                <div style="margin-left: -80px" class="el-icon-delete-solid" @click="delNaptPort(index)"></div>
              </el-col>
            </el-row>

          </div>
        </el-form-item>
        <el-form-item label="内网可用端口:" style=" margin-left: 135px;">
          <div>{{convertPortStr(ipItem)}}</div>
        </el-form-item>
        <el-form-item label="外网可用端口:" style=" margin-left: 135px;">
          <div>{{convertPortStr(selectIpItem)}}</div>
        </el-form-item>
        <el-row style="text-align: center; margin-top: 20px">
          <el-button type="primary" @click="setNaptMapping()">确 定</el-button>
          <el-button @click="resetPortMapForm()">取 消</el-button>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "NetMap",
    data() {
      let validateport = (rule, value, callback) => {
        const val = Number(value);

        if (val == 0) {
          return
        } else if (val > 65535 || val < 0) {
          callback(new Error('请输入正确的端口'))
          return
        }
        //field---0.portRange/ports   1.下标  2.value/start/end
        const field = rule.field.split('.');
        const ports = this.portFormData.ports;
        let arrsrcPort = new Set(); //所有源的端口
        let arrdstPort = [];//所有目标的端口\协议
        let dstObjArray = null;
        let broPort = [];
        let flag = 0;
        if (field[0] == 'ports') {
          broPort = ports.filter((p, id) => id != Number(field[1]))
          dstObjArray = ports.filter((p, id) => id == Number(field[1]))
        }
        broPort.forEach(b => {
          if (b.srcPort == null) {

          } else {
            arrsrcPort.add(Number(b.srcPort))
          }
          if (b.dstPort == null) {

          } else {
            arrdstPort.push({
              port: Number(b.dstPort),
              protocol: b.protocol
            })
          }
        })
        if (field[2] == 'srcPort') {
          if (arrsrcPort.has(val)) {
            callback(new Error('该端口已存在'));
            return
          }
          if (this.ipItem && this.ipItem.portArray) {
            let isexist = this.ipItem.portArray.some(p => p == val);
            if (!isexist) {
              let rangeExist = false;
              if (this.ipItem && this.ipItem.portRange) {
                rangeExist = this.ipItem.portRange.some(r => val >= r.start && val <= r.end);
              }
              if (!rangeExist) {
                callback(new Error('端口号不在范围之内'))
              }
            }
          } else {
            if (this.ipItem && this.ipItem.portRange) {
              let rangeExist = this.ipItem.portRange.some(r => val >= r.start && val <= r.end);
              if (!rangeExist) {
                callback(new Error('端口号不在范围之内'))
              }
            }
          }
        } else {
          let dstObj = dstObjArray[0];
          if (this.selectIpItem && this.selectIpItem.bindPortList) {
            this.selectIpItem.bindPortList.forEach(e => {
              arrdstPort.push({
                port: e.port,
                protocol: e.protocol
              })
            })
          }
          if (arrdstPort && arrdstPort.length > 0) {
            for (let i = 0; i < arrdstPort.length; i++) {
              let _dstObj = arrdstPort[i];
              if (dstObj.dstPort == _dstObj.port) {
                if (_dstObj.protocol == 3) {
                  callback(new Error(`端口已被TCP/UDP占用`))
                }
                if (_dstObj.protocol == dstObj.protocol || dstObj.protocol == 3) {
                  callback(new Error(`端口已被${_dstObj.protocol == 1 ? 'UDP' : _dstObj.protocol == 2 ? 'TCP' : ''}占用`))
                }
              }
            }
          }
          if (this.selectIpItem && this.selectIpItem.portArray) {
            let isexist = this.selectIpItem.portArray.some(p => p == val);
            if (!isexist) {
              let rangeExist = false;
              if (this.selectIpItem && this.selectIpItem.portRange) {
                rangeExist = this.selectIpItem.portRange.some(r => val >= r.start && val <= r.end);
              }
              if (!rangeExist) {
                callback(new Error('端口号不在范围之内'))
              }
            }
          } else {
            if (this.selectIpItem && this.selectIpItem.portRange) {
              let rangeExist = this.selectIpItem.portRange.some(r => val >= r.start && val <= r.end);
              if (!rangeExist) {
                callback(new Error('端口号不在范围之内'))
              }
            }
          }
        }
        callback()
      }
      return {
        portMap: false,
        selectIpItem: null,
        wanIpTableData: [],
        contentMultipleSelection: [],
        typeFormData: {
          NetType: "NAT",
        },
        portFormData: {
          ports: []
        },
        rules: {
          port: [{validator: validateport, trigger: 'blur'}],
        }
      }
    },
    methods: {
      close() {
        this.$emit('editCallback')
      },
      selectTable(row, index) {
        return row.status
      },
      convertPortStr(item) {
        let _port = "";
        if (item && item.portArray) {
          _port = item.portArray.join(",")
        }
        let _portRange = "";
        if (item && item.portRange) {
          item.portRange.forEach(e => {
            _portRange = e.start + "-" + e.end + ",";
          })
        }
        let _returnStr = "";
        if (_port) {
          _returnStr = _port
        }
        if (_portRange) {
          _returnStr = _port + "," + _portRange
        }
        return _returnStr
      },
      handleSelectionChangePrivateChoice(contents) {
        //let newIndexs = [];
        for (let i = 0; i < this.wanIpTableData.length; i++) {
          let obj = this.wanIpTableData[i];
          obj.isSelect = false;
        }
        this.contentMultipleSelection = [];
        for (let content of contents) {
          // let index = this.contentMultipleSelection.findIndex(
          //   item => item.ipStr + "" + item.id === content.ipStr + "" + content.id
          // );
          // newIndexs.push(this.wanIpTableData.findIndex(val => val.ipStr + "" + content.id === content.ipStr + "" + content.id));
          // if (index === -1) {
          //
          //   this.contentMultipleSelection.unshift(content);
          // }
          this.contentMultipleSelection.push(content)
          for (let i = 0; i < this.wanIpTableData.length; i++) {
            let obj = this.wanIpTableData[i];
            if (obj.id == content.id) {
              obj.isSelect = true;
            }
          }
        }
        // let _this = this;
        // // 新旧对比，如果旧的有的新的没有，那么就删除这个
        // for (let old of _this.currentPageCheckedIndexs) {
        //   if (newIndexs.findIndex(newIndex => newIndex === old) === -1) {
        //     let index = _this.contentMultipleSelection.findIndex(
        //       item => item.netPlaneName + "" + item.id === _this.privateTableData[old].netPlaneName + "" + _this.privateTableData[old].id
        //     );
        //     if (index !== -1) {
        //       _this.contentMultipleSelection.splice(index, 1);
        //     }
        //   }
        // }
        // _this.currentPageCheckedIndexs = newIndexs;
      },
      setPort(item) {
        this.selectIpItem = item;
        let _this = this;
        _this.portFormData.ports = [];
        _this.addNaptPort();
        if (_this.netIpMappingList) {
          for (let i = 0; i < _this.netIpMappingList.length; i++) {
            let obj = _this.netIpMappingList[i];
            if (obj.id == item.id && obj.portMapping.length > 0) {
              _this.portFormData.ports = obj.portMapping;
            }
          }
        }
        this.portMap = true;
        this.$nextTick(() => {
          this.$refs["portFormData"].clearValidate()
        })
      },
      addNaptPort() {
        this.portFormData.ports.push({
          srcPort: null,
          dstPort: null,
          protocol: 3
        });
      },
      delNaptPort(idx) {
        this.portFormData.ports.splice(idx, 1);
      },
      setNaptMapping() {
        for (let content of this.portFormData.ports) {
          if (content.srcPort == null || content.dstPort == null) {
            this.$message({
              showClose: true,
              message: "请确保端口信息正确且完整",
              type: "warning"
            });
            return;
          }
        }
        let _this = this;
        this.$refs["portFormData"].validate((valid) => {
          if (valid) {
            let data = {
              "ipId": this.ipItem.id,
              "relationId": this.selectIpItem.id,
              "relationType": 2,
              "portMapping": []
            };
            //先删除预保存数据集合里面的relationId相同的数据
            let _preSaveData = []
            for (let content of _this.preSaveData) {
              if (content.relationId != this.selectIpItem.id) {
                _preSaveData.push(content)
              }
            }
            _this.preSaveData = _preSaveData;
            for (let content of _this.portFormData.ports) {
              data.portMapping.push({
                "srcPort": Number(content.srcPort),
                "dstPort": Number(content.dstPort),
                "protocol": content.protocol
              })
            }
            _this.preSaveData.push(data);
            _this.portMap = false;
          } else {
            console.log('请确保端口信息正确且完整');
            return false;
          }
        });
      },
      resetPortMapForm() {
        this.portMap = false;
      },
      setNatMapping() {
        let arrayParam = [];
        let _this = this;
        let paramData = {
          "ipId": this.ipItem.id,
          "ipMappingList": []
        };
        for (let content of _this.contentMultipleSelection) {
          if (content.netType == "NAPT") {
            for (let i = 0; i < _this.preSaveData.length; i++) {
              let relationobj = _this.preSaveData[i];
              if (relationobj.relationId == content.id) {
                arrayParam.push(relationobj)
              }
            }
          } else {
            let data = {
              "relationId": content.id,
              "relationType": 1
            };
            arrayParam.push(data)
          }
        }
        paramData.ipMappingList = arrayParam;
        this.saveNatMapping(paramData)
      },
      saveNatMapping(data) {
        var _this = this;
        this.$axios.post(this.baseUrl3 + 'management3/ipmapping/update', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              //_this.netmap = false;
              this.$emit('editCallback', true);
              this.$message.success("操作成功！");
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      getWanIpList() {
        var data = {
          'pageNo': 1,
          'pageSize': 100000000,
          'idcId': this.idcId
        };
        var _this = this;
        _this.wanIpTableData = [];
        this.$axios.post(this.baseUrl3 + 'management3/wanip/list', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              let ipList = data.IpList;
              ipList.forEach((data, index) => {
                data.netType = "NAT"
              });
              _this.wanIpTableData = ipList;
              _this.$nextTick(() => {
                _this.getMappingInfo();
              })
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      getMappingInfo() {
        var data = {
          'id': this.ipItem.id,
          'idcId': this.idcId
        };
        var _this = this;
        _this.netIpMappingList = [];
        _this.preSaveData = [];
        _this.wanIpTableData = [];
        this.$axios.post(this.baseUrl3 + 'management3/netipmapping/list', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              _this.netmap = true;
              let arrayIdx = [];
              let arrayTypeIdx = [];
              data.IpListDto.forEach((data, index) => {
                data.netType = "NAT"
              });
              _this.wanIpTableData = data.IpListDto;
              if (data.MappingBindList) {
                for (let i = 0; i < data.MappingBindList.length; i++) {
                  let obj = data.MappingBindList[i];
                  _this.wanIpTableData.forEach((data, index) => {
                    if (data.id == obj.id) {
                      if (obj.portMapping && obj.portMapping.length > 0) {
                        data.netType = "NAPT";
                        let preData = {
                          "ipId": _this.ipItem.id,
                          "relationId": obj.id,
                          "relationType": 2,
                          "portMapping": []
                        }
                        for (let content of obj.portMapping) {
                          preData.portMapping.push({
                            "srcPort": content.srcPort,
                            "dstPort": content.dstPort,
                            "protocol": content.protocol,
                          })
                        }
                        _this.preSaveData.push(preData)
                      }
                    }
                  });
                  arrayIdx.push(data.MappingBindList[i].id)
                }
              }
              _this.netIpMappingList = data.MappingBindList;
              _this.$nextTick(() => {
                _this.wanIpTableData.forEach((data, index) => {
                  _this.$refs.priNetPlaneTable.toggleRowSelection(
                    _this.wanIpTableData[index],
                    false
                  );
                });
                _this.wanIpTableData.forEach((data, index) => {
                  if (
                    data &&
                    arrayIdx.findIndex(
                      id => id === data.id
                    ) !== -1
                  ) {
                    _this.$refs.priNetPlaneTable.toggleRowSelection(
                      _this.wanIpTableData[index],
                      true
                    );
                  }
                });
              });
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      resetForm(val) {
        this.$emit('editCallback', val)
      },
    },
    props: {
      netmap: {
        type: Boolean
      },
      idcId: {
        type: Number
      },
      ipItem: {
        type: Object
      },
    },
    created() {
      //this.getWanIpList();
      this.getMappingInfo();
    }
  }
</script>

<style scoped>
  .portDiv {
    margin-bottom: 20px;
  }
</style>
